import {
	// eslint-disable-next-line graphql-relay-compat/no-import-apollo-functions -- Read http://go/cfe-no-import-apollo-functions
	useQuery,
} from '@apollo/react-hooks';
import type { ApolloError } from 'apollo-client';

import { SpaceDetailQuery } from './SpaceDetailQuery.graphql';

export type SpaceDetailDataType = {
	spaceId: string;
	type: string;
	name: string;
	alias?: string;
	dataClassificationTags: string[];
	homepage?: {
		id: string;
		title: string;
		type: string;
	};
	iconPath?: string;
};

interface CommonHookResult {
	loading: boolean;
	error?: ApolloError;
}

export interface SpaceDetailType extends CommonHookResult {
	data?: SpaceDetailDataType;
}

export const useSpaceDetail = (spaceKey: string | null | undefined): SpaceDetailType => {
	// eslint-disable-next-line graphql-client-usage/graphql-generic-types
	const { loading, data, error } = useQuery(
		// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Preloaded GraphQL Operation
		SpaceDetailQuery,
		{
			variables: {
				spaceKey,
			},
			fetchPolicy: 'cache-first',
		},
	);

	return {
		loading,
		data: data && {
			spaceId: data.space?.id,
			type: data.space?.type,
			name: data.space?.name,
			dataClassificationTags: data.space?.dataClassificationTags,
			alias: data.space?.alias,
			homepage: data.space?.homepage,
			iconPath: data.space?.icon?.path,
		},
		error,
	};
};
